import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/v1.0/auth/login',
    register: '/api/auth/register',
    reset_password: '/auth/reset-password',
    send_otp: '/auth/send-otp',
    logout: `/auth/logout`,
  },

  website:{
    root:'/api/v1.0/website',
    new:'/api/v1.0/website',
    get_all:'/api/v1.0/website',
  },

  emailList:{
    root:'/api/v1.0/email'
  }

};
